export const NOTES_EVENTS = {
    CREATE_NOTE: "CREATE_NOTE",
    UPDATE_NOTE: "UPDATE_NOTE",
    DELETE_NOTE: "DELETE_NOTE",
    RESET_NOTES: "RESET_NOTES",
    SET_NOTES_LIST: "SET_NOTES_LIST",
};

export const CREATE_NOTE = {
    START: "CREATE_NOTE_START",
    SUCCESS: "CREATE_NOTE_SUCCESS",
    ERROR: "CREATE_NOTE_ERROR",
};

const defaultCreateNoteState = {
    createNoteLoading: false,
    createNoteData: false,
    createNoteError: false,
};

export const UPDATE_NOTE = {
    START: "UPDATE_NOTE_START",
    SUCCESS: "UPDATE_NOTE_SUCCESS",
    ERROR: "UPDATE_NOTE_ERROR",
};

const defaultUpdateNoteState = {
    updateNoteLoading: false,
    updateNoteData: false,
    updateNoteError: false,
};

export const DELETE_NOTE = {
    START: "DELETE_NOTE_START",
    SUCCESS: "DELETE_NOTE_SUCCESS",
    ERROR: "DELETE_NOTE_ERROR",
};

const defaultDeleteNoteState = {
    deleteNoteLoading: false,
    deleteNoteData: false,
    deleteNoteError: false,
};

export const NOTES = {
    CREATE_NOTE,
    UPDATE_NOTE,
    DELETE_NOTE,
};

const defaultState = {
    ...defaultCreateNoteState,
    ...defaultUpdateNoteState,
    ...defaultDeleteNoteState,
    notesList: [],
};

const notesReducer = (state = defaultState, action = {}) => {
    switch (action.event) {
        case NOTES_EVENTS.CREATE_NOTE:
            return {
                ...state,
                createNoteLoading: action.type === CREATE_NOTE.START,
                createNoteData: action.type === CREATE_NOTE.SUCCESS ? action.payload : false,
                createNoteError: action.type === CREATE_NOTE.ERROR ? action.payload : false,
            };
        case NOTES_EVENTS.UPDATE_NOTE:
            return {
                ...state,
                updateNoteLoading: action.type === UPDATE_NOTE.START,
                updateNoteData: action.type === UPDATE_NOTE.SUCCESS ? action.payload : false,
                updateNoteError: action.type === UPDATE_NOTE.ERROR ? action.payload : false,
            };
        case NOTES_EVENTS.DELETE_NOTE:
            return {
                ...state,
                deleteNoteLoading: action.type === DELETE_NOTE.START,
                deleteNoteData: action.type === DELETE_NOTE.SUCCESS ? action.payload : false,
                deleteNoteError: action.type === DELETE_NOTE.ERROR ? action.payload : false,
            };
        case NOTES_EVENTS.SET_NOTES_LIST:
            return {
                ...state,
                notesList: action.payload,
            };
        case NOTES_EVENTS.RESET_NOTES:
            return defaultState;
        default:
            return state;
    }
};

export default notesReducer;
